import { render, staticRenderFns } from "./PlanDeatail.vue?vue&type=template&id=a4bf49f4&scoped=true&"
import script from "./PlanDeatail.vue?vue&type=script&lang=js&"
export * from "./PlanDeatail.vue?vue&type=script&lang=js&"
import style0 from "./PlanDeatail.vue?vue&type=style&index=0&id=a4bf49f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4bf49f4",
  null
  
)

export default component.exports